import { render, staticRenderFns } from "./vCardGeneric.vue?vue&type=template&id=f26ed16c&"
import script from "./vCardGeneric.vue?vue&type=script&lang=js&"
export * from "./vCardGeneric.vue?vue&type=script&lang=js&"
import style0 from "./vCardGeneric.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports